import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const DropdownClosedIcon = (props) => (
    <SvgIcon {...props}>
      <polygon fill="#616161" points="14.571,6 14.571,18 9.429,12 "/>
    </SvgIcon>
);

export default DropdownClosedIcon;



// WEBPACK FOOTER //
// ./src/icons/DropdownClosedIcon.jsx